import { Button } from '@/components/Button/Button';
import { PageZoom } from '@/components/PageZoom/PageZoom';
import { Spinner } from '@/components/Spinner/Spinner';
import type { BBox } from '@/papermill/extraction';
import { usePageImage } from '@/papermill/usePageImage';

import styles from './SourceViewer.module.css';

/** The page a value was read from, out of the warm page cache; `onRetry` re-signs its link. */
export function SourceViewer({
  url,
  bbox,
  label,
  onRetry,
}: {
  url: string;
  bbox: BBox;
  label: string;
  onRetry?: () => void;
}) {
  const state = usePageImage(url, bbox.page);

  if (state.status === 'ready') {
    return <PageZoom {...state.image} bbox={bbox} label={label} />;
  }
  return (
    <div className={styles.placeholder}>
      {state.status === 'loading' ? (
        <>
          <Spinner />
          <span>Opening page {bbox.page + 1}…</span>
        </>
      ) : (
        <>
          <span>The document preview could not be loaded.</span>
          {onRetry ? (
            <Button variant="ghost" onClick={onRetry}>
              Try again
            </Button>
          ) : null}
        </>
      )}
    </div>
  );
}
